<template>
  <div id="show_info" style="width:1198px;">
    <el-table
      :data="tableData"
      style="width: 100%;padding:0"
      :span-method="arraySpanMethod"
    >
      <!-- 票品详情 英文状态 -->
      <el-table-column  v-if="!CheckCN()" label="Ticket details" width="520px;">
        <template slot-scope="scope">
          <div class="info_wrap" @click="geToDetail">
            <div class="info_left">
              <img
                :src="advance_icon"
                alt
                class="advance_tips"
                v-if="advance_flag"
              />
              <img :src="scope.row.showPic" alt />
            </div>
            <div class="info_right">
              <p class="info_title">{{ scope.row.projectName }}</p>
              <p class="info_date">{{ scope.row.performName }}</p>
              <p class="info_address">
                {{ scope.row.venueName }}
                <span class="info_address_br"></span>
                {{ scope.row.cityName }}
              </p>
              <p
                class="is-damai-ticket"
                v-if="
                  (evFlag == 1 && scope.row.merchantId == 1225) ||
                    (evFlag == 2 && scope.row.merchantId == 884)
                "
              >
                {{TLang('该票务由大麦网提供','my')}}
              </p>
              <p class="info_level" v-if="false">
                {{TLang('票档','my')}}
                <span class="info_level_answer">{{ scope.row.priceName }}</span>
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <!-- 票品详情 中文状态 -->
      <el-table-column v-if="CheckCN()" label="票品详情" width="520px;">
        <template slot-scope="scope">
          <div class="info_wrap" @click="geToDetail">
            <div class="info_left">
              <img
                :src="advance_icon"
                alt
                class="advance_tips"
                v-if="advance_flag"
              />
              <img :src="scope.row.showPic" alt />
            </div>
            <div class="info_right">
              <p class="info_title">{{ scope.row.projectName }}</p>
              <p class="info_date">{{ scope.row.performName }}</p>
              <p class="info_address">
                {{ scope.row.venueName }}
                <span class="info_address_br"></span>
                {{ scope.row.cityName }}
              </p>
              <p
                class="is-damai-ticket"
                v-if="
                  (evFlag == 1 && scope.row.merchantId == 1225) ||
                    (evFlag == 2 && scope.row.merchantId == 884)
                "
              >
                {{TLang('该票务由大麦网提供','my')}}
              </p>
              <p class="info_level" v-if="false">
                {{TLang('票档','my')}}
                <span class="info_level_answer">{{ scope.row.priceName }}</span>
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <!-- 票档 英文状态 -->
      <el-table-column
        v-if="!CheckCN()"
        label="Ticket level"
        width="196px;
      margin-left:0px;"
      >
        <template slot-scope="scope">
          <div v-for="count in scope.row.seatNum" :key="`tritem${count}`">
            <div style="width:176px;display:inline-block;vertical-align: top">
              <!-- <span>{{ scope.row.priceName[count - 1] }}</span> -->
              <span
                v-for="item in scope.row.priceName[`level${count - 1}`]"
                :key="`price${item}`"
                style="display:block"
                >{{ item }}</span
              >
            </div>
            <div style="width:196px;padding:0 10px 0 20px;display:inline-block">
              <div
                v-for="(seat_item, seat_index) in scope.row.seatInfoObj[
                  count - 1
                ]"
                :key="`seat${seat_index}`"
              >
                <span>{{ seat_item }}</span>
              </div>
            </div>
            <div
              style="width:114px;padding-left:20px;
            display:inline-block;vertical-align: top"
            >
              <span>{{ formatPrice(scope.row.ticketPrice[count - 1]) }}</span>
              <span style="font-style: normal;font-size:12px;">{{
                formatPrice(scope.row.ticketPrice[count - 1], "fixed")
              }}</span
              >{{
                JSON.stringify(unionInfo) != "{}" && unionInfo.name
                  ? unionInfo.name
                  : ""
              }}
              &times;{{ scope.row.quantity[count - 1] }}
            </div>
          </div>
        </template>
      </el-table-column>
      <!-- 票档 中文文状态 -->
      <el-table-column
        v-if="CheckCN()"
        label="票档"
        width="196px;
      margin-left:0px;"
      >
        <template slot-scope="scope">
          <div v-for="count in scope.row.seatNum" :key="`tritem${count}`">
            <div style="width:176px;display:inline-block;vertical-align: top">
              <!-- <span>{{ scope.row.priceName[count - 1] }}</span> -->
              <span
                v-for="item in scope.row.priceName[`level${count - 1}`]"
                :key="`price${item}`"
                style="display:block"
                >{{ item }}</span
              >
            </div>
            <div style="width:196px;padding:0 10px 0 20px;display:inline-block">
              <div
                v-for="(seat_item, seat_index) in scope.row.seatInfoObj[
                  count - 1
                ]"
                :key="`seat${seat_index}`"
              >
                <span>{{ seat_item }}</span>
              </div>
            </div>
            <div
              style="width:114px;padding-left:20px;
            display:inline-block;vertical-align: top"
            >
              <span>{{ formatPrice(scope.row.ticketPrice[count - 1]) }}</span>
              <span style="font-style: normal;font-size:12px;">{{
                formatPrice(scope.row.ticketPrice[count - 1], "fixed")
              }}</span
              >{{
                JSON.stringify(unionInfo) != "{}" && unionInfo.name
                  ? unionInfo.name
                  : ""
              }}
              &times;{{ scope.row.quantity[count - 1] }}
            </div>
          </div>
        </template>
      </el-table-column>
      <!-- 坐位 英文状态 -->
      <el-table-column
        v-if="!CheckCN()"
        label="Seat"
        width="196px;
        margin-left:0px;"
      >
        <template slot-scope="scope">
          <div
            v-for="(seat_item, seat_index) in scope.row.seatInfo"
            :key="`seat${seat_index}`"
          >
            <span>{{ seat_item }}</span>
          </div>
        </template>
      </el-table-column>
      <!-- 坐位 中文状态 -->
      <el-table-column
        v-if="CheckCN()"
        label="座位"
        width="196px;
        margin-left:0px;"
      >
        <template slot-scope="scope">
          <div
            v-for="(seat_item, seat_index) in scope.row.seatInfo"
            :key="`seat${seat_index}`"
          >
            <span>{{ seat_item }}</span>
          </div>
        </template>
      </el-table-column>
      <!-- 单价(福豆) 英文状态 -->
      <el-table-column v-if="!CheckCN()" label="Unit Price(FuDou)"  width="124px;">
        <template slot-scope="scope">
          <div
            v-for="(price_item, price_index) in scope.row.ticketPrice"
            :key="`price${price_index}`"
          >
            <span>{{ formatPrice(price_item) }}</span>
            <span style="font-style: normal;font-size:12px;">{{
              formatPrice(price_item, "fixed")
            }}</span>
            &times;{{ scope.row.quantity[price_index] }}
          </div>
        </template>
      </el-table-column>
      <!-- 单价(福豆) 中文状态 -->
      <el-table-column v-if="CheckCN()" label="单价(福豆)" width="124px;">
        <template slot-scope="scope">
          <div
            v-for="(price_item, price_index) in scope.row.ticketPrice"
            :key="`price${price_index}`"
          >
            <span>{{ formatPrice(price_item) }}</span>
            <span style="font-style: normal;font-size:12px;">{{
              formatPrice(price_item, "fixed")
            }}</span>
            &times;{{ scope.row.quantity[price_index] }}
          </div>
        </template>
      </el-table-column>
      <!-- 小计(福豆) 英文状态 -->
      <el-table-column v-if="!CheckCN()" label="Subtotal(FuDou)" width="162px;" align="right">
        <template slot-scope="scope">
          <span>{{ formatPrice(scope.row.totalPrice) }}</span>
          <span>{{ formatPrice(scope.row.totalPrice, "fixed") }}</span>
        </template>
      </el-table-column>
      <!-- 小计(福豆) 中文状态 -->
      <el-table-column v-if="CheckCN()" label="小计(福豆)" width="162px;" align="right">
        <template slot-scope="scope">
          <span>{{ formatPrice(scope.row.totalPrice) }}</span>
          <span>{{ formatPrice(scope.row.totalPrice, "fixed") }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getCookie } from "@/utils";
export default {
  name: "OrderInfo",

  props: ["orderData", "advanceFlag", "orderPay", "evFlag"],

  data() {
    return {
      advance_icon: require("@/assets/imgs/advance_sale_img.png"),
      advance_flag: this.advanceFlag == 1 ? true : false,
      //advance_flag: this.advanceFlag
      tableData: JSON.stringify(this.orderData) != "{}" ? [this.orderData] : [],
      orderPay_flag: this.orderPay,
      CookiesOne: getCookie('df_lang'),
    };
  },
  created() {
    //console.log("this.tableData", this.orderData);
  },
  watch: {
    orderData: {
      handler: function(newVal) {
        this.tableData = [];
        JSON.stringify(newVal) != "{}"
          ? this.tableData.push(newVal)
          : (this.tableData = []);

        this.advance_flag = this.orderData.projectType == 1 ? true : false;
        console.log("this.tableData2", this.tableData);
      },
      deep: true,
      immediate: true
    },
    advanceFlag(val) {
      this.advance_flag = val == 1 ? true : false;
    },
    orderPay(val) {
      this.orderPay_flag = val;
    }
  },

  computed: {
    ...mapState({
      unionInfo: "unionInfo"
    })
  },

  methods: {
    //合并td单元格
    arraySpanMethod({ columnIndex }) {
      if (columnIndex === 1) {
        return [2, 3, 4];
      } else if (columnIndex === 2 || columnIndex === 3) {
        return [0, 0, 0];
      }
    },
    //规格化价格
    formatPrice(val, fixed) {
      let valNum = null;
      !val
        ? (val = "0.00")
        : this.unionInfo.scale
        ? (val = this.unionInfo.scale * Number(val))
        : val;
      if (!fixed) {
        val.toString().indexOf(".") != -1
          ? (valNum = val.toString().slice(0, val.toString().indexOf(".")))
          : (valNum = val);
      } else {
        val.toString().indexOf(".") != -1
          ? (valNum = val.toString().slice(val.toString().indexOf(".")))
          : (valNum = ".00");
      }
      return valNum;
    },
    //转详情页面
    geToDetail() {
      this.orderPay_flag
        ? this.$emit("toDetail", this.tableData[0].goodsId)
        : "";
    }
  }
};
</script>

<style scoped lang="less">
.line-clamp(@line: 2) {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: @line;
  overflow: hidden;
  text-overflow: ellipsis;
}
#show_info {
  font-weight: normal;
}
/deep/ .el-table th {
  padding: 0;
  border-bottom: 0 !important;
  height: 50px;
  line-height: 50px;
  background: rgba(247, 247, 247, 1);
  font-size: 12px;
  color: rgba(153, 153, 153, 1);
  font-weight: normal;
}
/deep/ .el-table {
  box-sizing: border-box;
}
/deep/ .el-table tr:hover td {
  background: #ffffff;
}
/deep/ .el-table th:nth-of-type(1) .cell,
/deep/ .el-table td:nth-of-type(1) .cell {
  padding-left: 24px;
}
/deep/ .el-table th:nth-of-type(2) .cell,
/deep/ .el-table td:nth-of-type(2) .cell {
  padding-left: 20px;
}
/deep/ .el-table th:nth-of-type(3) .cell,
/deep/ .el-table td:nth-of-type(3) .cell,
/deep/ .el-table th:nth-of-type(4) .cell,
/deep/ .el-table td:nth-of-type(4) .cell {
  padding-left: 20px;
  width: 130px;
}
/deep/ .el-table th:nth-of-type(5) .cell,
/deep/ .el-table td:nth-of-type(5) .cell {
  padding-right: 24px;
}
/deep/ .el-table td:nth-of-type(3) .cell,
/deep/ .el-table td:nth-of-type(5) .cell {
  padding-right: 24px;
  font-weight: bold;
  color: rgba(34, 34, 34, 1);
  span {
    font-weight: bold;
    color: rgba(34, 34, 34, 1);
    display: inline-block;
  }
}

/deep/ .el-table::before {
  // background-color: #fff;
  height: 0;
}
/deep/ .el-table td {
  padding: 20px 0 17px 0;
  vertical-align: top !important;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  border-bottom: none !important;
}
.el-table td .info_left,
.el-table td .info_right {
  float: left;
}
.el-table td .info_left {
  position: relative;
  width: 80px;
  height: 106px;
  margin-top: 4px;
  img {
    width: 100%;
    height: 100%;
    vertical-align: middle;
    display: inline-block;
  }
  .advance_tips {
    width: 28px;
    height: 16px;
    position: absolute;
    right: 0;
    top: 0;
  }
}
.info_wrap {
  display: flex;
  cursor: pointer;
}
.info_wrap::after {
  content: "";
  display: block;
  visibility: hidden;
  height: 0;
  clear: both;
}
.el-table td .info_right {
  font-size: 12px;
  margin-left: 14px;
  .info_title {
    height: 40px;
    width: 372px;
    // height: 40px;
    .line-clamp(@line: 2);
    font-size: 14px;
    color: rgba(0, 0, 0, 1);
    line-height: 20px;
  }
  .info_date {
    color: rgba(102, 102, 102, 1);
    line-height: 14px;
    margin: 4px 0 2px;
  }
  .info_address {
    color: rgba(102, 102, 102, 1);
    line-height: 16px;
    .info_address_br {
      width: 1px;
      height: 10px;
      background: rgba(203, 205, 206, 1);
      display: inline-block;
      margin: 0 4px;
    }
  }
  .info_level {
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 17px;
    margin-top: 20px;
    .info_level_answer {
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      margin-left: 12px;
    }
  }
  .is-damai-ticket {
    color: #999;
    font-size: 12px;
    line-height: 16px;
    margin-top: 18px;
  }
}
</style>
